import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

interface Props {
  handleConfirm: Function;
  handleCancalation: Function;
  handleDownloadDocs: Function;
  handlePrint: Function;
  handleExportExcel: Function;
}
const SettlementRequestDetailActionsHeader = ({
  handleCancalation,
  handleConfirm,
  handleDownloadDocs,
  handleExportExcel,
  handlePrint,
}: Props) => {
  return (
    <div>
      <Grid
        container
        sx={{
          backgroundColor: "#F6F8F9",
          border: "1px solid #EDEFEF",
          borderRadius: "5px",
          padding: "10px 25px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* export section */}
        <Grid item sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="پرینت" arrow>
              <PrintOutlinedIcon
                sx={{ fontSize: "27px", color: "#1D4A87" }}
                onClick={() => handlePrint()}
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={() => handleExportExcel()}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box>
        </Grid>
        {/* actions sections */}
        <Grid item>
          <Box
            sx={{
              display: { xs: "block", md: "flex" },
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Typography
              sx={{ color: "#28A745", cursor: "pointer" }}
              onClick={() => handleConfirm()}
            >
              <CheckOutlinedIcon
                sx={{ fontSize: "1.5rem", marginLeft: "3px" }}
              />
              تایید تسویه
            </Typography>
            <Typography
              sx={{ color: "#E6123D", cursor: "pointer" }}
              onClick={() => {
                handleCancalation();
              }}
            >
              <ClearOutlinedIcon
                sx={{ fontSize: "1.5rem", marginLeft: "3px" }}
              />
              رد درخواست تسویه
            </Typography>
            <Typography
              sx={{ color: "#1D4A87", cursor: "pointer" }}
              onClick={() => {
                handleDownloadDocs();
              }}
            >
              <FileDownloadOutlinedIcon
                sx={{ fontSize: "1.5rem", marginLeft: "3px" }}
              />
              دانلود مستندات
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default SettlementRequestDetailActionsHeader;
